var map = {
	"./basketball.webp": 1658,
	"./bti-img.webp": 1659,
	"./bti-title-en.webp": 1660,
	"./cup.webp": 1661,
	"./football.webp": 1662,
	"./im-img.webp": 1663,
	"./im-title-en.webp": 1664,
	"./sb-img.webp": 1665,
	"./sb-title-cn.webp": 1666,
	"./sb-title-en.webp": 1667,
	"./sbo-img.webp": 1668,
	"./sbo-title-cn.webp": 1669,
	"./sbo-title-en.webp": 1670,
	"./sport-bg.webp": 1671,
	"./sport-ctg.webp": 1672,
	"./title-cn.webp": 1673,
	"./title-en.webp": 1674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 786;